import React,{useEffect} from 'react';
import Tittle from '../Components/Tittle';
import allBlogs from '../Components/allBlogs';
import ScrollAnimation from 'react-animate-on-scroll';
import Aos from "aos"
import "aos/dist/aos.css"
import Fade from 'react-reveal/Fade';

function BlogsPage() {
    useEffect(() =>{
        Aos.init({durations:4000});
    },[]);
    return (
        <Fade left>
        <div className="Blog" >
            <div className="b-title">
                <Tittle title={'Education'} span={'education'} />
            </div>
           
           

            <div   className="BlogsPage">
                {
                    allBlogs.map((blog)=>{
                        return(                        
                        
                         <div data-aos="fade-right"  className="blog" key={blog.id}>
                            <div className="blog-content">
                            <a href={blog.link} className="blog-link" target="_blank" >
                                <img src={blog.image} alt=""/>
                                {blog.title}
                                </a>
                                <p >{blog.date}</p>
                                <strong> <p className="cgpa">{blog.month}</p></strong>
                            </div>
                        </div>
                       
                        )
                    })
                }
            </div>
          
        </div>
        </Fade>
    )
}

export default BlogsPage;
